import React, { useEffect, useState } from "react";
import {
  ClickAwayListener,
  Fab,
  Fade,
  Paper,
  Typography,
  useTheme,
} from "@mui/material";
import { Box } from "@mui/system";

import { useAppSelector } from "../../app/hooks";
import { ReactComponent as Close } from "../../assets/svg/Close.svg";
import {
  selectAvailableCraft,
} from "../../features/aircraft/aircraftSelectors";
import { SelectAircraftItem } from "./SelectAircraftItem";
import { ReactComponent as Add } from "../../assets/svg/Plus.svg";
import { selectCanConnect } from "../../features/session/sessionSlice";

export const AircraftMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const canConnect = useAppSelector(selectCanConnect);

  const theme = useTheme();
  const fabRef = React.useRef<HTMLButtonElement | null>(null);

  const [aircrafts, setAircrafts] = useState<string[]>([]);

  useEffect(() => {
    const parseQueryParams = () => {
      const params = new URLSearchParams(window.location.search);
      const localAircraft = params.getAll("aircraft");
      setAircrafts(localAircraft);
    };

    parseQueryParams();
  }, []);

  const onClickAway = () => {
    if (menuOpen) {
      setMenuOpen(false);
    }
  };

  const availableCraft = useAppSelector(selectAvailableCraft);
  const onClickFab = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setMenuOpen(!menuOpen);
  };

  useEffect(() => {
    const handleTouch = (e: TouchEvent) => {
      e.preventDefault();
      setMenuOpen(!menuOpen);
    };

    const element = fabRef.current;
    element?.addEventListener("touchstart", handleTouch, { passive: false });

    return () => {
      element?.removeEventListener("touchstart", handleTouch);
    };
  }, [menuOpen]);

  return (
    <Box sx={{ pointerEvents: "none" }}>
      <Fab
        ref={fabRef}
        disabled={!canConnect}
        sx={{
          position: "absolute",
          bottom: 16,
          right: 16,
          pointerEvents: "all",

          backgroundColor: theme.palette.background.paper,
        }}
        aria-label={"fab"}
        color={"default"}
        onClick={onClickFab}
      >
        {menuOpen ? (
          <Close stroke={theme.palette.text.primary} />
        ) : (
          <Add stroke={theme.palette.text.primary} />
        )}
      </Fab>
      <ClickAwayListener onClickAway={onClickAway}>
        <div>
          <Fade in={menuOpen} unmountOnExit>
            <Paper
              sx={{
                pointerEvents: "all",
                marginBottom: 11,
                marginRight: 2,
                width: 375,
                padding: 2,
                borderRadius: 2,
              }}
            >
              <Box sx={{}} display={"flex"}>
                <Typography variant={"h6"} fontWeight={"600"}>
                  Add Aircraft
                </Typography>
              </Box>
              <Box display={"flex"} mt={1} flexDirection={"column"}>
                {availableCraft.map((aircraft) => {
                  return (
                    <Box key={`select-ac-item-${aircraft}`}>
                      <SelectAircraftItem uavId={aircraft} port=":5000" />
                    </Box>
                  );
                })}
                {aircrafts ? (
                  <>
                    {aircrafts.map((aircraft, i) => {
                      return (
                        <Box key={`select-ac-item-100${i + 1}`}>
                          <SelectAircraftItem
                            uavId=""
                            sims={[
                              {
                                ip: aircraft,
                                active: false,
                                available: false,
                                status: "ok",
                              },
                            ]}
                            port=":5000"
                          />
                          <Box mb={2}></Box>
                        </Box>
                      );
                    })}
                  </>
                ) : null}
              </Box>
              {availableCraft.length === 0 ? (
                <Box display={"flex"} flexDirection={"row"}>
                  <Box display={"flex"} alignItems={"center"}>
                    <Typography
                      variant={"h6"}
                      color={theme.palette.text.primary}
                    >
                      {`No aircraft online.`}
                    </Typography>
                  </Box>
                </Box>
              ) : null}
            </Paper>
          </Fade>
        </div>
      </ClickAwayListener>
    </Box>
  );
};
